import { User } from "~/api/models";

export enum SessionActions {
    SET_USER = 'SESSION/SET_USER'
}

export type SessionAction = {
    type: SessionActions
    payload?: User
}